import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
} from "reactstrap";
import Dropzone from "react-dropzone";
import { get, cloneDeep } from "lodash";
import download from "downloadjs";
import { NotificationManager } from "react-notifications";
import { Trans } from "react-i18next";

export default ({ item, setItem, xero, close }) => {
  let url = `contacts/${item.ContactID}/attachments`;

  const [pending, setPending] = useState(false);

  // TODO: do something with errors? Comment out just now to remove warning
  //const [errors, setErrors] = useState();

  const onDropAccepted = ([file]) => {
    setPending(true);
    //setErrors(null);

    const reader = new FileReader();
    reader.onload = (e) => {
      let data = {
        filename: file.name,
        content: e.target.result,
      };
      xero
        .post(url, data)
        .then(
          (r) => {
            NotificationManager.success("File uploaded");
            let tmp = cloneDeep(item);
            tmp.Attachments.push(r.data.Attachments[0]);
            setItem(tmp);
          },
          (err) => {
            const detail = get(err, "response.data.detail");
            if (detail && detail.length) {
              //setErrors(detail);
            } else {
              throw err;
            }
          }
        )
        .finally(() => setPending(false));
    };
    reader.readAsDataURL(file);
  };

  const onDownload = async (attachment) => {
    let r = await xero
      .get(`${url}/${attachment.FileName}?mimetype=${attachment.MimeType}`)
      .get("data");
    download(r.content.replace(/\s/g, ""), r.filename);
  };

  // TODO: Delete attachments

  return (
    <Modal isOpen toggle={close}>
      {item.Attachments.length > 0 && (
        <ModalHeader>
          <Trans>Related Files</Trans>
        </ModalHeader>
      )}
      <ModalBody style={{ padding: 0 }}>
        {item.Attachments.length === 0 ? (
          <div style={{ padding: "1rem" }}>
            <div>
              <Trans>Upload files</Trans>
            </div>
            <p>
              <Trans>
                Only users with access to your company can view these files.
              </Trans>
            </p>
          </div>
        ) : (
          <Table hover>
            <tbody>
              {item.Attachments.map((x) => (
                <tr key={x.AttachmentID} style={{ cursor: "pointer" }}>
                  <td onClick={() => onDownload(x)}>{x.FileName}</td>
                  {/* <td> */}
                  {/*   <a href="##" onClick={e => {e.preventDefault(); onDelete(x.AttachmentID)}}> */}
                  {/*     <span className="fa fa-times" /> */}
                  {/*   </a> */}
                  {/* </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        <Dropzone
          multiple={false}
          disablePreview={true}
          disabled={pending}
          style={{}}
          className={pending ? "btn btn-primary disabled" : "btn btn-primary"}
          onDropAccepted={onDropAccepted}
          maxSize={3000000}
        >
          {pending && <span className="fa fa-fw fa-spin fa-spinner mr-1" />}
          <span className="fa fa-plus mx-1" /> <Trans>Upload files...</Trans>
        </Dropzone>
        <Button onClick={close}>
          <Trans>Cancel</Trans>
        </Button>
      </ModalFooter>
    </Modal>
  );
};
